import axios from "axios";

export const getSettingsByOfferingId = (offeringId) => {
  return new Promise(function (resolve, reject) {
    axios
      .get(`/offering/${offeringId}/setting`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const getInvestReadyUrl = () => {
  return new Promise(function (resolve, reject) {
    axios
      .get(`/webhook/investready/url`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const isConvertibleOffering = (stockType) => {
  return (
    stockType === "convertible_note" ||
    stockType === "In lieu of cash with Convertible Notes" ||
    stockType?.includes("Unit with convertible notes")
  );
};

export const isRegD506COffering = (exemption_type) => {
  return exemption_type === "REG_D_506_C";
};

export const isCommonStockType = (stockType) => {
  if (!stockType) return false;

  return (
    stockType === "common_stock" ||
    stockType.includes("Common Stock") ||
    stockType === "preferred_stock" ||
    stockType.includes("Preferred Stock") ||
    stockType?.includes("In lieu of cash with common stock") ||
    stockType.includes("Unit with common stock")
  );
};
